export default __webpack_public_path__ + "static/media/dashboard-new-folio-icon-light.226ee7d1.svg";